<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25 text-primary"
        href="https://dentaltwin.de/en/"
        target="_blank"
        >DentalTwin GmbH</b-link
      >
      <span class="d-none d-sm-inline-block"
        >, {{ $t("allRightsReserved") }}</span
      >
    </span>

    <span class="float-md-left d-block d-md-inline-block mt-25 ml-1">
      |
      <b-link
        class="ml-1 text-primary"
        :href="$i18n.locale === 'de' ? 'https://dentaltwin.com/de/impressum/' : 'https://dentaltwin.com/imprint/'"
        target="_blank"
        >{{$t("impressum")}}</b-link
      >
    </span>

    <span class="float-md-left d-block d-md-inline-block mt-25 ml-1">
      |
      <router-link  class="ml-1 text-primary" to="/data-privacy">{{ $t("dataPrivacy") }}</router-link>
      <!-- <b-link
        class="ml-1 text-primary"
        href="https://dentaltwin.de/en/en-privacy-policy/"
        target="_blank"
        >Datenschutz</b-link
      > -->
    </span>

    <span class="float-md-right d-none d-md-block mt-25">
      {{ $t("madeInGermanyWith") }}
      <feather-icon
        icon="HeartIcon"
        size="14"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
